import { useSetupStore } from '../../store/setupStore';
import { generateFeedbackPlan } from '../../utils/generatePlan';

const ReviewStep = () => {
  const { setup } = useSetupStore();

  const selectedCategories = setup.selectedCategories.filter(
    (category) => category.selected
  );

  const feedbackPlan = generateFeedbackPlan(setup);

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-900">Review Your Setup</h2>
      <div className="space-y-4">
        <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm">
          <h3 className="font-medium text-gray-900 mb-2">Class Schedule</h3>
          <p className="text-gray-600">
            {setup.totalClasses} classes, meeting {setup.frequency}
          </p>
        </div>
        <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm">
          <h3 className="font-medium text-gray-900 mb-2">Feedback Collection</h3>
          <p className="text-gray-600">
            {setup.feedbackType === 'entrance' ? 'Entrance' : 'Exit'} tickets with{' '}
            {setup.questionsPerSession} questions per session
          </p>
          <p className="text-gray-600 mt-1">
            Starting from beginning of semester
          </p>
        </div>
        <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm">
          <h3 className="font-medium text-gray-900 mb-2">
            Selected Categories ({selectedCategories.length})
          </h3>
          <ul className="space-y-2">
            {selectedCategories.map((category) => (
              <li key={category.id} className="flex justify-between text-gray-600">
                <span>{category.name}</span>
                <span>
                  Week {category.week}
                </span>
              </li>
            ))}
          </ul>
        </div>
        {feedbackPlan.length > 0 && (
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm">
            <h3 className="font-medium text-gray-900 mb-2">Feedback Plan</h3>
            <div className="space-y-4">
              {feedbackPlan.map((classPlan) => (
                <div key={classPlan.classNumber} className="border-t border-gray-200 pt-4 first:border-t-0 first:pt-0">
                  <h4 className="font-medium text-gray-900 mb-2">
                    Class {classPlan.classNumber}
                  </h4>
                  <ul className="list-disc list-inside space-y-2">
                    {classPlan.questions.map((question, index) => (
                      <li key={`${question.id}-${index}`} className="text-gray-600">
                        {question.text}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReviewStep;